import React from "react";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import TooltipHLPure from "../tooltipHL/tooltipHL.pure";
import { newAnadirIconForButton } from "../../../assets/logos/icons/index";
import "./inputFileESignHL.css";

const InputFileESignHLPure = (props) => {
  const {
    labelInputFile, //Label input File
    messageBtn, //Text in button
    acceptType, //".key" or  ".cer" file type
    selectedFile, // True or false, did you select any file?
    selectedFileName, //Name file selected
    errorFile, //Error to select file, true or false
    handleFileESignChange, //Function onClick to recived file
    tooltipShow, //True or false to show tooltip
    positionTooltip, //Position tooltip (top, left, right, bottom) string
    titleTooltip, //Title tooltip string
    descriptionTooltip, //Description tooltip string
    subContent, //More text to tooltip description optional
    restContent, //More text to tooltip description optional
    informationIcon, // Choose the information icon true or false to custom img
  } = props;

  const { t } = useTranslation();

  //Function filter key or cer
  // const handleFile = (e) => {
  //   if (e.target.files.length > 0) {
  //     let filename = e.target.files[0].name;
  //     let filenameArray = filename.split(".");
  //     let extension = filenameArray[filenameArray.length - 1];

  //     if (extension === "key") {
  //       if (extension === "key" || extension === "pem") {
  //         setSelectedFileKey(e.target.files[0]);
  //         setErrorFile(false);
  //         setSelectedFileKeyName(filename);
  //       } else {
  //         setSelectedFileKey(null);
  //         setErrorFile(true);
  //         setSelectedFileKeyName(t("inputFileESignHLPure.notuploadDocument"));
  //         return false;
  //       }
  //     } else if (extension === "cer") {
  //       if (extension === "cer" || extension === "pem") {
  //         setSelectedFileCer(e.target.files[0]);
  //         setErrorFileCer(false);
  //         setSelectedFileCerName(filename);
  //       } else {
  //         setSelectedFileCer(null);
  //         setErrorFileCer(true);
  //         setSelectedFileCerName(t("inputFileESignHLPure.notuploadDocument"));
  //         return false;
  //       }
  //     }
  //   } else {
  //     return false;
  //   }
  // };

  //Funtion to delete file
  // const handleDeleteFile = (e) => {
  //   setSelectedFileKey(null);
  //   setErrorFile(false);
  //   setSelectedFileCer(null);
  //   setErrorFileCer(false);
  //   return true;
  // };

  return (
    <Grid
      container
      lg={12}
      md={12}
      sm={12}
      es={12}
      className="inputFileESignHLPure-container-all"
    >
      <Grid
        item
        className="inputFileESignHLPure-container-text"
        xs={12}
        lg={12}
        md={12}
        sm={12}
        es={12}
      >
        {labelInputFile ? (
          <label className="inputFileESignHLPure-label">{labelInputFile}</label>
        ) : (
          ""
        )}
        {tooltipShow ? (
          <TooltipHLPure
            positionTooltip={positionTooltip}
            titleTooltip={titleTooltip}
            descriptionTooltip={descriptionTooltip}
            subContent={subContent}
            restContent={restContent}
            informationIcon={informationIcon}
          />
        ) : (
          ""
        )}
      </Grid>
      <Grid
        item
        className="inputFileESignHLPure-container-upload"
        xs={12}
        lg={12}
        md={12}
        sm={12}
        es={12}
      >
        <Grid
          item
          xs={12}
          lg={4}
          md={5}
          sm={5}
          es={6}
          className="inputFileESignHLPure-btnUpload"
        >
          <div className="inputFileESignHLPure-style">
            <img
              className="inputFileHL-icon"
              src={newAnadirIconForButton}
            ></img>
            <input
              type="file"
              // id="fileKey"
              className="inputFileHL-files"
              accept={acceptType}
              onChange={(e) => {
                handleFileESignChange(e);
              }}
            />
            {messageBtn}
          </div>
          {/* <div
            onClick={handleDeleteFile}
            className="inputFileESignHLPure-icon-trash"
          >
            <i className="inputFileHL-icon-trash k-icon k-i-delete k-i-trash"></i>
          </div> */}
        </Grid>
        <Grid
          item
          xs={12}
          lg={5}
          md={6}
          sm={6}
          es={6}
          className={
            selectedFile
              ? "inputFileESignHLPure-documentContainer"
              : "inputFileESignHLPure-documentContainerAlign"
          }
        >
          {/**Button name file */}
          <div className="inputFileESignHLPure-file-leyend">
            <p className="inputFileESignHLPure-leyend-name">
              {!selectedFile === null
                ? `${t("inputFileESignHLPure.notuploadDocument")}`
                : `${selectedFileName}`}
            </p>
          </div>
          {selectedFile ? (
            <span className="inputFileESignHLPure-leyend-icon">
              <i className="k-icon k-i-check-circle k-i-checkmark-circle inputFileESignHLPure-icon "></i>
            </span>
          ) : null}
          {errorFile === true ? (
            <span className="inputFileESignHLPure-message-error">
              {t("inputFileESignHLPure.extentionPDFNotValid")}
            </span>
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  );
};

export { InputFileESignHLPure as default };
